module.exports = window["__sharedReactRedux"];